import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { POLICY_STATUS } from '../../../constants';

import styles from './PolicyStatusPill.module.css';

export const PolicyStatusPill = ({ status = POLICY_STATUS.cancelled }) => {
  const { t } = useTranslation('insurance');

  const styleBysStatus = useMemo(() => {
    switch (status) {
      case POLICY_STATUS.active:
        return styles.active;

      case POLICY_STATUS.future:
        return styles.future;

      case POLICY_STATUS.past:
      case POLICY_STATUS.cancelled:
      default:
        return styles.cancelled;
    }
  }, [status]);

  return (
    <span className={`${styles.statusChip} ${styleBysStatus}`}>
      &#9679; {t(`policyStatus-${status}`)}
    </span>
  );
};
